module.exports = __webpack_public_path__ + "static/img/tu4@1x.77afac7.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/tu4@1x.png
// module id = 39eS
// module chunks = 2